import styles from "./campaignfilter.module.css";
import { Link } from "react-router-dom";
import { Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";

const CampaignFilter = ({ setFilterData }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
            </div>
        </div>
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign:create") > -1 && <div className={`${styles.FilterSec}`}>
            <Link to={`/campaign/campaigns/add`} className={`${styles.AddNoteBu}`}>
                <Plus /> <span>Template</span>
            </Link>
        </div>}
    </div>);
}

export default CampaignFilter;